import {useParams} from 'react-router-dom';

import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';

export const useHttpMonitorUnsubscribe = () => {
    const {uuid} = useParams();
    const {data, isLoading, isError} = httpMonitorAPI.useGetDomainOfHttpMonitorQuery(uuid ?? '', {skip: !uuid});
    const [trigger] = httpMonitorAPI.useLazyUnsubscribeHttpMonitorQuery();

    const unsubscribeHandler = async() => {
        return trigger(uuid ?? '').unwrap();
    };

    return {
        domain: data?.domain ?? '',
        isLoading,
        isNotFound: !uuid || isError,
        unsubscribeHandler,
    };
};

export default useHttpMonitorUnsubscribe;
